module.exports = __webpack_public_path__ + "img/phosphorus.9c6c41d0.png";